/**
 * Women Micro-Infusion offer buy box
 * Two Intelligems gates on #nm-wo-root:
 *   data-activation-class       → full PDP treatment (legacy AB)
 *   data-buybox-activation-class → optional gate for buy-box-only
 * Default (buybox class blank): always show buy-box-only.
 * Full class on html/body still switches to full treatment.
 */
(function () {
  'use strict';

  if (window.__NM_WO_OFFER_INIT) return;
  window.__NM_WO_OFFER_INIT = true;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function hasPageClass(cls) {
    if (!cls) return false;
    return (
      document.documentElement.classList.contains(cls) ||
      document.body.classList.contains(cls)
    );
  }

  /** @returns {'buybox'|'full'|null} null = gated and not activated yet */
  function resolveMode(root) {
    var bbCls = (root.getAttribute('data-buybox-activation-class') || '').trim();
    var fullCls = (root.getAttribute('data-activation-class') || '').trim();
    // Legacy full treatment still wins when its IG class is present
    if (fullCls && hasPageClass(fullCls)) return 'full';
    // No buybox gate → live default is buy-box-only
    if (!bbCls) return 'buybox';
    if (hasPageClass(bbCls)) return 'buybox';
    return null;
  }

  function shouldActivate(root) {
    return resolveMode(root) !== null;
  }

  function selectNativeVariant(cfg) {
    var radio = qs('input[name="Bundle & save"][value="' + cfg.variantOptionValue + '"]');
    if (radio && !radio.checked) radio.click();
    var idInput = qs(
      '.main-product-form input[name="id"], .product-form input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (idInput) {
      idInput.value = String(cfg.variantId);
      idInput.disabled = false;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setPurchaseMode(mode, cfg) {
    selectNativeVariant(cfg);
    var autoShip = qs('#auto-ship');
    var oneTime = qs('#one-time');
    if (mode === 'sub') {
      if (autoShip && !autoShip.classList.contains('active')) autoShip.click();
      else if (autoShip && !qs('.loop-w-checkbox-purchase-option.loop-widget-purchase-option-selected')) {
        var hdr = qs('.loop-w-checkbox-purchase-option-header');
        if (hdr) hdr.click();
      }
      var info = qs('.product__info-container');
      if (info) info.classList.add('subscription-on');
    } else {
      if (oneTime && !oneTime.classList.contains('active')) oneTime.click();
      var info2 = qs('.product__info-container');
      if (info2) info2.classList.remove('subscription-on');
    }
  }

  function setOptUI(root, mode) {
    qsa('[data-opt]', root).forEach(function (el) {
      el.setAttribute('aria-checked', el.getAttribute('data-opt') === mode ? 'true' : 'false');
    });
  }

  function openJump(kind) {
    var target = kind === 'faq' ? qs('#faq') : qs('#Ingredients');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (kind === 'faq') {
      setTimeout(function () {
        var first = target.querySelector(
          'details.accordion__details:not([open]) summary, .accordion details:not([open]) summary'
        );
        if (first) first.click();
      }, 350);
    } else {
      qsa('h2, h3, h4, h5, .accordion__title').forEach(function (h) {
        if (!/ingredient/i.test(h.textContent || '')) return;
        var d = h.closest('details');
        if (d && !d.open) {
          var sum = d.querySelector('summary');
          if (sum) sum.click();
          else d.open = true;
        }
      });
    }
  }

  function wireReels(root, assets) {
    qsa('[data-reel]', root).forEach(function (r) {
      var v = r.querySelector('video');
      var ic = r.querySelector('.snd img');
      if (!v) return;
      r.addEventListener('click', function () {
        if (v.paused) {
          qsa('[data-reel] video', root).forEach(function (o) {
            if (o === v) return;
            o.pause();
            o.muted = true;
            var img = o.closest('[data-reel]').querySelector('.snd img');
            if (img) img.src = assets.volX;
          });
          v.muted = false;
          if (ic) ic.src = assets.vol2;
          v.play().catch(function () {
            v.muted = true;
            if (ic) ic.src = assets.volX;
            v.play().catch(function () {});
          });
        } else if (v.muted) {
          qsa('[data-reel] video', root).forEach(function (o) {
            if (o === v) return;
            o.muted = true;
            var img = o.closest('[data-reel]').querySelector('.snd img');
            if (img) img.src = assets.volX;
          });
          v.muted = false;
          if (ic) ic.src = assets.vol2;
        } else {
          v.pause();
          v.muted = true;
          if (ic) ic.src = assets.volX;
        }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) e.target.play().catch(function () {});
              else e.target.pause();
            });
          },
          { threshold: 0.4 }
        ).observe(v);
      }
    });
  }

  function wireSheet(sheet) {
    var lockY = 0;
    function openSheet() {
      lockY = window.scrollY || 0;
      sheet.classList.add('on');
      document.body.style.cssText =
        'position:fixed;top:' + -lockY + 'px;left:0;right:0;overflow:hidden';
    }
    function closeSheet() {
      sheet.classList.remove('on');
      document.body.style.cssText = '';
      window.scrollTo(0, lockY);
    }
    var x = qs('#nm-wo-sheet-x', sheet);
    var ok = qs('#nm-wo-sheet-ok', sheet);
    if (x) x.addEventListener('click', closeSheet);
    if (ok) ok.addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) closeSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('on')) closeSheet();
    });
    return openSheet;
  }

  function addToCart(btn, cfg) {
  var modeEl = qs('#nm-wo-bb [data-opt][aria-checked="true"]');
  var isSub = !(modeEl && modeEl.getAttribute('data-opt') === 'otp');

  setPurchaseMode(isSub ? 'sub' : 'otp', cfg);

  // CheckoutChamp-enabled PDPs:
  // use the existing product/variant COC metafields instead of Shopify cart.
  var cocInput = qs(
    '.pp_config-coc-data[data-id="' + cfg.variantId + '"]'
  );

  if (cocInput) {
    var domain = (cocInput.dataset.domain || '').trim();
    var cocId = (
      (isSub ? cocInput.dataset.subCoc : cocInput.dataset.otpCoc) || ''
    ).trim();

    if (!domain || !cocId) {
      console.warn('[NM Women Offer][COC] Missing CheckoutChamp config', {
        variantId: cfg.variantId,
        subscription: isSub,
        domain: domain,
        cocId: cocId,
      });
      return;
    }

    window.location.href =
      domain + '?products=' + encodeURIComponent(cocId);

    return;
  }

  btn.disabled = true;

  var item = { id: cfg.variantId, quantity: 1 };
    if (isSub) {
      var sp = qs('input[name="selling_plan"]');
      item.selling_plan = sp && sp.value ? Number(sp.value) : cfg.sellingPlanId;
    }

    if (typeof window.__nmShowFreebieCartLoader === 'function') {
      window.__nmShowFreebieCartLoader();
    }
    window.__nmBlockAutoGiftAdds = true;
    window.__nmSuppressDuplicateGuide = true;

    var drawer = qs('cart-drawer');

    function postCartItems(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    }

    function womenGiftLines(variantId, subscription) {
      var cfgMap = (window.NM_STRAWS_FREEBIE_CONFIG || {});
      var map = cfgMap.mainToFreebieMap || {};
      var base = Number(map[variantId] || map[String(variantId)] || 0);
      var lines = [];
      if (base) {
        var subs = cfgMap.subscriptionSubstitutes || {};
        var plans = cfgMap.subscriptionSellingPlans || {};
        var giftId = subscription && subs[base] ? Number(subs[base]) : base;
        var line = { id: giftId, quantity: 1 };
        if (subscription) {
          var plan = Number(plans[giftId] || plans[String(giftId)] || 0);
          if (plan) line.selling_plan = plan;
        }
        // Product 7746648670285 is eligible for automatic additions only with a subscription.
        var restrictOtpPipettes = !subscription &&
          (cfgMap.otpPipetteRestrictedHandles || []).indexOf(cfg.productHandle) !== -1;
        if (!restrictOtpPipettes || [42899705987149, 42899706019917, 42899706052685].indexOf(giftId) === -1) {
          lines.push(line);
        }
      }
      lines.push({ id: 41898147807309, quantity: 1 });
      return lines;
    }

    postCartItems([item])
      .then(function () {
        return window.refreshCartDrawer();
      })
      .then(function () {
        if (drawer && typeof drawer.open === 'function') drawer.open();
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 1000);
        });
      })
      .then(function () {
        var gifts = womenGiftLines(cfg.variantId, isSub);
        if (!gifts.length) return null;
        window.__nmGiftAddBypass = true;
        return postCartItems(gifts)
          .catch(function () {
            return null;
          })
          .finally(function () {
            window.__nmGiftAddBypass = false;
          });
      })
      .then(function () {
        window.__nmBlockAutoGiftAdds = false;
        return window.refreshCartDrawer();
      })
      .then(function () {
        if (typeof window.__nmEndAtcGiftLoaderSession === 'function') {
          window.__nmEndAtcGiftLoaderSession();
        }
        window.setTimeout(function () {
          window.__nmSuppressDuplicateGuide = false;
        }, 1500);
      })
      .catch(function () {
        window.__nmBlockAutoGiftAdds = false;
        window.__nmGiftAddBypass = false;
        window.__nmSuppressDuplicateGuide = false;
        var native =
          qs('.main-product-form .product-form__submit') ||
          qs('.product-form__submit.main-product-atc');
        if (native) native.click();
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  function patchThumbnailActiveSync() {
    qsa('media-gallery').forEach(function (gallery) {
      if (gallery.getAttribute('data-nm-wo-patched') === '1') return;
      if (typeof gallery.setActiveThumbnail !== 'function') return;
      gallery.setAttribute('data-nm-wo-patched', '1');

      function escapeAttr(value) {
        if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
        return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      }

      function syncThumbByMediaId(mediaId) {
        if (!mediaId || !gallery.elements.thumbnails) return;
        var thumb = gallery.elements.thumbnails.querySelector(
          '[data-target="' + escapeAttr(mediaId) + '"]'
        );
        if (thumb) gallery.setActiveThumbnail(thumb);
      }

      function syncIsActiveByMediaId(mediaId) {
        if (!mediaId) return;
        gallery.querySelectorAll('.product__media-item[data-media-id]').forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
        });
      }

      gallery.setActiveThumbnail = function (thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach(function (el) {
          el.removeAttribute('aria-current');
        });
        var btn = thumbnail.querySelector('button.thumbnail') || thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');

        // Scroll rail only when the thumb is actually clipped — avoids jump back/forth
        var list =
          this.elements.thumbnails.slider ||
          this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        if (!list) return;
        var pad = 4;
        var left = thumbnail.offsetLeft;
        var right = left + thumbnail.offsetWidth;
        var viewLeft = list.scrollLeft;
        var viewRight = viewLeft + list.clientWidth;
        if (left < viewLeft + pad) {
          list.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
        } else if (right > viewRight - pad) {
          list.scrollTo({ left: Math.max(0, right - list.clientWidth + pad), behavior: 'smooth' });
        }
      };

      // Keep last known media from slideChanged. Theme swipe updates currentPage but
      // may leave .is-active stale; our old 520ms re-sync then restored the wrong thumb.
      var viewer = gallery.elements && gallery.elements.viewer;
      if (viewer) {
        viewer.addEventListener('slideChanged', function (event) {
          var current = event.detail && event.detail.currentElement;
          var mediaId = current && current.dataset && current.dataset.mediaId;
          if (mediaId) {
            gallery.__nmWoLastMediaId = mediaId;
            syncIsActiveByMediaId(mediaId);
            syncThumbByMediaId(mediaId);
          }

          clearTimeout(gallery.__nmWoThumbSync);
          gallery.__nmWoThumbSync = setTimeout(function () {
            // Prefer last slideChanged id; fall back to .is-active only if needed
            var id = gallery.__nmWoLastMediaId;
            if (!id) {
              var active = gallery.querySelector('.product__media-item.is-active');
              id = active && active.getAttribute('data-media-id');
            }
            if (id) {
              syncIsActiveByMediaId(id);
              syncThumbByMediaId(id);
            }
          }, 520);
        });
      }

      // Also keep thumb in sync when setActiveMedia runs (thumbnail click / our arrows)
      if (typeof gallery.setActiveMedia === 'function' && !gallery.__nmWoSetActivePatched) {
        gallery.__nmWoSetActivePatched = true;
        var nativeSetActiveMedia = gallery.setActiveMedia.bind(gallery);
        gallery.setActiveMedia = function (mediaId, prepend) {
          if (mediaId) gallery.__nmWoLastMediaId = mediaId;
          return nativeSetActiveMedia(mediaId, prepend);
        };
      }
    });
  }

  function wireThumbnailArrows() {
    var rail = qs('media-gallery .thumbnail-slider');
    if (!rail || rail.getAttribute('data-nm-wo-arrows') === '1') return;
    rail.setAttribute('data-nm-wo-arrows', '1');

    var gallery = rail.closest('media-gallery');
    var list = qs('[id^="Slider-Thumbnails"]', rail);
    var prev = qs('button[name="previous"]', rail);
    var next = qs('button[name="next"]', rail);
    if (!list || !prev || !next) return;

    function unlock() {
      if (prev.hasAttribute('disabled')) prev.removeAttribute('disabled');
      if (next.hasAttribute('disabled')) next.removeAttribute('disabled');
    }

    unlock();
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(unlock);
      mo.observe(prev, { attributes: true, attributeFilter: ['disabled'] });
      mo.observe(next, { attributes: true, attributeFilter: ['disabled'] });
    }

    function visibleItems() {
      return qsa('.thumbnail-list__item', list).filter(function (li) {
        return li.clientWidth > 0 && li.getAttribute('data-target');
      });
    }

    function step(dir) {
      unlock();
      var items = visibleItems();
      if (!items.length) return;

      var activeBtn = qs('.thumbnail[aria-current="true"], .thumbnail[aria-current]', list);
      var activeLi = activeBtn ? activeBtn.closest('.thumbnail-list__item') : null;
      var idx = activeLi ? items.indexOf(activeLi) : 0;
      if (idx < 0) idx = 0;
      var nextLi = items[(idx + dir + items.length) % items.length];
      var mediaId = nextLi && nextLi.getAttribute('data-target');
      if (!mediaId) return;

      // Use gallery API directly — avoids double handlers / aria-current flicker from .click()
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        var thumbBtn = qs('button.thumbnail', nextLi);
        if (thumbBtn) thumbBtn.click();
      }
    }

    prev.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        step(-1);
      },
      true
    );
    next.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        step(1);
      },
      true
    );
  }

  function boot() {
    var root = qs('#nm-wo-root');
    if (!root || root.getAttribute('data-nm-wo-ready') === '1') return;
    var mode = resolveMode(root);
    if (!mode) return;

    root.setAttribute('data-nm-wo-ready', '1');
    var buyboxOnly = mode === 'buybox';

    // Do NOT mutate html/body — Intelligems watches those and flags infinite loops.
    var productHost = root.closest('.product');
    if (productHost) {
      productHost.classList.add('nm-wo-active');
      productHost.classList.toggle('nm-wo-bb-only', buyboxOnly);
    }
    root.classList.add('nm-wo-active');
    root.classList.toggle('nm-wo-bb-only', buyboxOnly);

    var cfg = {
      productHandle: root.getAttribute('data-product-handle') || '',
      variantId: Number(root.getAttribute('data-variant-id')) || 43713518305357,
      variantOptionValue: root.getAttribute('data-variant-option') || 'Buy 1 Get 2 FREE',
      sellingPlanId: Number(root.getAttribute('data-selling-plan-id')) || 19500793933,
    };

    var assets = {
      volX: root.getAttribute('data-icon-vol-x') || '',
      vol2: root.getAttribute('data-icon-vol-2') || '',
    };

    var sheet = qs('#nm-wo-sheet');
    var openSheet = sheet ? wireSheet(sheet) : null;

    // Full-page arm only: place "See It in Action" under the main product section
    var see = qs('#nm-wo-see');
    if (!buyboxOnly && see && see.getAttribute('data-nm-wo-placed') !== '1') {
      var mainSection = root.closest('.shopify-section');
      if (!mainSection) {
        var productEl = qs('.product');
        if (productEl) mainSection = productEl.closest('.shopify-section');
      }
      if (mainSection && mainSection.parentNode) {
        mainSection.insertAdjacentElement('afterend', see);
        see.setAttribute('data-nm-wo-placed', '1');
      }
      see.classList.add('nm-wo-active');
      see.hidden = false;
      see.removeAttribute('hidden');
    }

    setOptUI(root, 'sub');
    setPurchaseMode('sub', cfg);

    var bb = qs('#nm-wo-bb', root);
    if (bb) {
      bb.addEventListener('click', function (e) {
        if (e.target.closest('#nm-wo-gift-info')) return;
        var t = e.target.closest('[data-opt]');
        if (!t) return;
        var modeOpt = t.getAttribute('data-opt');
        setOptUI(root, modeOpt);
        setPurchaseMode(modeOpt, cfg);
      });
      bb.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var t = e.target.closest('[data-opt]');
        if (!t) return;
        e.preventDefault();
        t.click();
      });
    }

    var giftInfo = qs('#nm-wo-gift-info', root);
    if (giftInfo && openSheet) {
      giftInfo.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSheet();
      });
    }

    var buy = qs('#nm-wo-buy', root);
    if (buy) {
      buy.addEventListener('click', function () {
        addToCart(buy, cfg);
      });
    }

    qsa('[data-nm-jump]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        openJump(a.getAttribute('data-nm-jump'));
      });
    });

    if (!buyboxOnly) {
      wireReels(see || root, assets);
      patchThumbnailActiveSync();
      wireThumbnailArrows();
    }
  }

  // Poll for root + optional Intelligems class (no MutationObserver on html/body — IG flags that as a loop)
  ready(function () {
    var tries = 0;
    (function tick() {
      tries += 1;
      var root = qs('#nm-wo-root');
      if (root) {
        if (shouldActivate(root)) {
          boot();
          return;
        }
        // Root exists but IG class not yet — keep polling briefly
        if (tries < 100) {
          setTimeout(tick, 100);
          return;
        }
        return;
      }
      if (tries < 40) setTimeout(tick, 150);
    })();
  });
})();
